const NoObjectionAttachments = [
  {
    name: "Official Application Letter",
    description: "Official Application Letter",
    is_mandatory: true,
    info: "",
  },
  {
    name: "Legal Status Document",
    description: "Legal Status Document",
    is_mandatory: true,
    info: "",
  },
  {
    name: "Project Analysis Form",
    description: "Project Analysis Form",
    is_mandatory: true,
    info: "",
  },
  {
    name: "Stakeholder’s consultation proof",
    description: "Stakeholder’s consultation proof",
    is_mandatory: true,
    info: "",
  },
  {
    name: "Concept Note/Full Proposal",
    description: "Concept Note/Full Proposal",
    is_mandatory: true,
    info: "",
  },
  {
    name: "Cofinancing Letters",
    description: "Cofinancing Letters",
    is_mandatory: false,
    info: "",
  },
  {
    name: "Existing Concept/Full Proposal",
    description: "Existing Concept/Full Proposal",
    is_mandatory: false,
    info: "",
  },
  {
    name: "New Concept Note /Full Proposal",
    description: "New Concept Note /Full Proposal",
    is_mandatory: false,
    info: "",
  },
  {
    name: "Existing No-Objection Letter",
    description: "Existing No-Objection Letter",
    is_mandatory: false,
    info: "",
  },
]

export default NoObjectionAttachments
